import { Environment } from '../enums';

const environmentInformation: { [key in Environment]: { name: string; color: string } } = {
    [Environment.DEV]: { name: 'Development environment', color: '#3CB043' },
    [Environment.SANDBOX]: { name: 'Sandbox environment', color: '#f28500' },
    [Environment.PRODUCTION]: { name: 'Production environment', color: '#D0312D' },
};

export default environmentInformation;
